<template lang="pug">
  .TerritoryDocument
    .TerritoryDocument-close(v-if="!isUploading")
      button.Btn.BtnIcon(@click="closePopup")
        i.Icon.IconClose
    .TerritoryDocument-header
      h2 Параметры документа

    .TerritoryDocument-body
      .Params
        .Params-field
          .Params-label.Params-label--required Название документа
          textarea(
            maxlength="255"
            :class='{"Textarea--error": showErrors && !params.name}',
            v-model="params.name")
          input-notification(v-if="showErrors && !params.name") Обязательное поле

        .Params-field
          .Params-label.Params-label--required Файл
          file-upload(:initialFile="params.file", @changeFile="changeFile", :types="types")
          input-notification(v-if="showErrors && (!params.file || (!params.file.file && !params.file.url))")  Обязательное поле
    .TerritoryDocument-footer
      div
        button.Btn.Btn--blue.Btn--light(
          @click="save",
          :disabled="isUploading") Сохранить
        button.Btn.Btn--grey.Btn--light(@click="closePopup") Отмена
      div(v-if="document && document.id")
        button.Btn.Btn--remove.Btn--light.Btn--icon(@click="remove")
          i.Icon.IconRemove
          span Удалить

</template>

<script>
import FileUpload from '@/components/FileUpload'
import Switcher from '@/components/Switcher'
export default {
  name: 'TerritoryDocument',
  components: {
    FileUpload,
    Switcher,
    'input-notification': () => import('@/components/InputNotification')
  },
  data() {
    return {
      isUploading: false,
      params: {
        name: '',
        file: null
      },
      showErrors: false
    }
  },
  props: {
    document: {
      type: Object,
      default: () => {}
    },
    types: {
      type: Array,
      default: () => {
        return []
      }
    },
    docType: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.params = this.document ? { ...this.params, ...this.document } : { ...this.params }
  },
  methods: {
    dragoverprevent(e) {
      e.preventDefault()
    },
    remove() {
      this.$ui.popup.ok({ action: 'remove' })
    },
    save() {
      const params = {
        name: this.params.name
      }
      if (this.params.file && this.params.file.file) {
        params.file = this.params.file.file
      }
      if (this.validate()) {
        if (!this.document) {
          const action = this.docType === 'control' ? 'addControl' : 'addTerschema'
          this.$store
            .dispatch(action, params)
            .then((r) => {
              this.$ui.toast.show({ text: 'Документ создан', type: 'success' })
              this.$ui.popup.ok()
            })
            .catch((e) => {
              this.$store.commit('setApiErrorInfo', 'При создании документа произошла ошибка. Данные не сохранены')
            })
        } else {
          params.id = this.document.id
          const action = this.docType === 'control' ? 'updateControl' : 'updateTerschema'
          this.$store
            .dispatch(action, params)
            .then((r) => {
              this.$ui.toast.show({ text: 'Документ обновлен', type: 'success' })
              this.$ui.popup.ok()
            })
            .catch((e) => {
              this.$store.commit('setApiErrorInfo', 'При обновлении документа произошла ошибка. Данные не сохранены')
            })
        }
      }
    },
    changeFile(file) {
      this.params.file = file
    },
    validate() {
      this.showErrors = true
      return (
        this.params.name &&
        this.params.file &&
        (this.params.file.url || this.params.file.file) &&
        (!this.params.file.errors || this.params.file.errors.length === 0)
      )
    },
    closePopup() {
      this.$ui.popup.ok({ status: this.status })
    }
  }
}
</script>
<style lang="scss">
@import '~base';

.Popup .TerritoryDocument {
  --footerBorder: #{$grey3};
  --textError: #{$red};
}

.Popup[data-theme='dark'] .TerritoryDocument {
  --footerBorder: #{$grey2};
  --textError: #{$red};
}
</style>
<style scoped lang="scss">
@import '~base';

.TerritoryDocument {
  position: relative;

  &-close {
    position: absolute;
    top: 10px;
    right: 15px;

    .Icon {
      font-size: 14px;
    }
  }

  &-header {
    padding: 25px 30px 0;

    h2 {
      margin-bottom: 0;
      font-size: 16px;
      text-transform: uppercase;
    }
  }

  &-body {
    padding: 25px 30px 0 30px;
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    padding: 5px 30px 10px;
    border-top: 1px solid var(--footerBorder);

    .Btn {
      min-width: 155px;
    }

    .Btn + .Btn {
      margin-left: 12px;
    }
  }

  .Btn--remove {
    .Icon {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/TerritoryDocument.vue